"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const menu_item_style_1 = __importDefault(require("./menu.item.style"));
class MenuItem extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, label, onClick, icon, suffix, selected, bold } = this.props;
            const rootProps = {
                role: 'menuitem',
                className: classes.root
            };
            const buttonProps = {
                type: 'button',
                onClick,
                'data-is-selected': selected,
                className: classes.button
            };
            const spanProps = {
                className: classes.label,
                'data-is-bold': bold
            };
            return (jsx_runtime_1.jsx("li", Object.assign({}, rootProps, { children: jsx_runtime_1.jsxs("button", Object.assign({}, buttonProps, { children: [icon && jsx_runtime_1.jsx("span", Object.assign({ className: classes.icon }, { children: icon }), void 0),
                        jsx_runtime_1.jsx("span", Object.assign({}, spanProps, { children: label }), void 0),
                        suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }), void 0) }), void 0));
        };
    }
}
exports.MenuItem = MenuItem;
MenuItem.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.string.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    icon: prop_types_1.default.node,
    suffix: prop_types_1.default.node,
    selected: prop_types_1.default.bool,
    bold: prop_types_1.default.bool
};
MenuItem.defaultProps = {
    icon: null,
    suffix: null,
    selected: false,
    bold: false
};
exports.default = react_jss_1.default(menu_item_style_1.default)(MenuItem);
//# sourceMappingURL=menu.item.js.map